import { ErrorHandler } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import { ErrorReporter } from '@mode/shared/contract-common';
import { BugsnagService } from '@mode/shared/util-error-handling';
import * as angular from 'angular';

export const DowngradedSharedUtilErrorHandlingModule = angular
  .module('downgraded-shared-util-error-handling', [])
  .service('BugsnagService', downgradeInjectable(BugsnagService))
  .service('ErrorReporter', downgradeInjectable(ErrorReporter))
  .service('AngularErrorHandler', downgradeInjectable(ErrorHandler)).name;
